export default __webpack_public_path__ + "static/media/architectural-blueprints.43c14030.webp";